export default function displayText() {
    return function (input) {

        if (input.indexOf('Commencing') === 0)
            return 'Commencing my first semester of study';

        return input;
    }
};